<template>
  <v-btn-toggle v-bind="$attrs" mandatory dense v-model="filterDivision">
    <v-btn v-bind="$attrs" outlined text :key="0">alle</v-btn>
    <v-btn
      v-bind="$attrs"
      outlined
      text
      v-for="division in divisions"
      :key="division.id"
      >{{ division.code }}</v-btn
    >
  </v-btn-toggle>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "DivisionFilterSingle",
  props: {
    value: 0,
  },
  data() {
    return {
      divisions: [],
      filterDivision: 0,
    };
  },
  watch: {
    filterDivision(newValue) {
      window.localStorage.setItem("filterDivisionSingle", newValue);
      this.$emit("input", newValue);
    },
    value() {
      this.filterDivision = this.value;
    },
  },
  async mounted() {
    this.divisions = await this.apiList({ resource: "common/division" });
    if (localStorage.getItem("filterDivisionSingle")) {
      this.filterDivision = parseInt(
        localStorage.getItem("filterDivisionSingle")
      );
    }
  },
});
</script>
